import z from 'zod'

import { REQUIRED_FIELD_MESSAGE } from '@/constants'
import type { OptionType, PaymentTypeInterface } from '@/types'

export const contractEditFormSchema = z.object({
  number: z.string().trim().min(1, 'Номер договора обязателен'),
  isActive: z.boolean(),
  paymentType: z.object(
    { value: z.string().min(1), label: z.string() },
    {
      required_error: 'Выберите способ оплаты',
      invalid_type_error: 'Выберите способ оплаты',
    }
  ),
})

export type ContractEditFormType = z.infer<typeof contractEditFormSchema>

export const getPaymentTypeOption = (
  paymentType: PaymentTypeInterface
): OptionType => ({
  value: paymentType.id,
  label: paymentType.paymentType === 'CASH' ? 'Наличные' : 'Безналичный',
})

export const contractCreationFormSchema = z.object({
  paymentType: z.string().trim().min(1, REQUIRED_FIELD_MESSAGE),
})

export const SELECT_OPTIONS = [
  { value: 'CASH', label: 'Наличные' },
  { value: 'NON_CASH', label: 'Безналичный' },
]
